import Validation from '../components/widgets/Validation';

export default {
    components: { Validation },

    props: {
        validation: Object,
        name: String,
        label: String,
        description: String,
        value: {},
        disabled: Boolean,
        horizontal: Boolean,
        autofocus: Boolean,
        labelClass: String,
    },

    data: () => ({
        hasFocus: false,
    }),

    computed: {
        required: vm => !vm.disabled
            && vm.validation
            && Object.prototype.hasOwnProperty.call(vm.validation, 'required'),

        widgetProps: vm => ({
            validation: vm.validation,
            name: vm.name,
            label: vm.label,
            description: vm.description,
            value: vm.value,
            disabled: vm.disabled,
            horizontal: vm.horizontal,
            labelClass: vm.labelClass,
        }),

        widgetClass: vm => ({
            'form-control': true,
            'is-valid': vm.validation && vm.validation.$dirty && !vm.validation.$error,
            'is-invalid': vm.validation && vm.validation.$error,
        }),
    },

    methods: {
        focus() {
            this.$refs.el.focus();
        },

        onFocus() {
            this.hasFocus = true;
            this.$emit('focus', this);
        },

        onBlur() {
            this.hasFocus = false;
            this.$emit('blur', this);
        },

        getClass(prefix = 'widget', secondary = null) {
            const classes = {};
            classes[`${prefix}`] = true;
            classes[`${prefix}--inline`] = this.inline;
            classes[`${prefix}--error`] = this.validation && this.validation.$error;
            classes[`${prefix}--${this.modifier}`] = this.modifier;

            if (secondary) {
                classes[`${secondary}`] = true;
                classes[`${secondary}--inline`] = this.inline;
                classes[`${secondary}--error`] = this.validation && this.validation.$error;
                classes[`${secondary}--${this.modifier}`] = this.modifier;
            }

            return classes;
        },

        validationFor(type) {
            if (!this.validation) {
                return null;
            }

            return Object.values(this.validation.$params).find(v => v.type === type) || null;
        },

        validationProp(type, prop) {
            const validation = this.validationFor(type);

            return validation ? validation[prop] : null;
        },
    },
};
